import React from 'react';
import { connect } from 'react-redux';
import Footer from "./components/Footer/Footer.jsx";

class Base extends React.Component {

	render() {
		return (
			<div className="content">
				<div className="container">
					<div className="wrapper">
						{this.props.children}
						<Footer fluid />
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Base);
